import { useFusionAuth } from "@fusionauth/react-sdk";
import Cookies from "js-cookie";

/**
 * Resolves the email of the back-office staff user currently signed in via
 * FusionAuth. Used as the `actorEmail` (audit `grantedBy`) for role changes.
 *
 * Prefers the FusionAuth session `user` object; falls back to the `user`
 * cookie FusionAuth populates with the same OIDC claims (the precedent used by
 * `TopNavbar`). Returns an empty string when no email can be resolved so
 * callers can guard before issuing a write.
 */
export const useActorEmail = (): string => {
  const { user } = useFusionAuth();

  if (user?.email) {
    return user.email as string;
  }

  try {
    const cookieValue = Cookies.get("user");
    if (cookieValue) {
      const parsed = JSON.parse(cookieValue) as { email?: string };
      return parsed?.email ?? "";
    }
  } catch {
    // Malformed cookie — fall through to the empty default.
  }

  return "";
};
